module.exports = __webpack_public_path__ + "static/media/9DESA6.da90db36.jpg";